module.exports = __webpack_public_path__ + "dash_20_app_assets/img/surs.5d791468.png";